<template>
  <div class="py-4 container-fluid">
    <!-- RINGKASAN SEMUA PROYEK -->
    <div class="row">
      <div class="col-lg-2 col-md-4 mb-3" v-for="(card, i) in cards" :key="'c'+i">
        <div class="card">
          <div class="card-body p-3">
            <p class="text-xs mb-1 text-uppercase font-weight-bold">{{ card.label }}</p>
            <h6 :class="'font-weight-bolder mb-0 '+card.color">{{ card.value }}</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-warning text-white text-sm" v-if="missingRates.length > 0">
      <i class="fa fa-exclamation-triangle"></i> Kurs <b>{{ missingRates.join(', ') }}</b> belum diisi, nilai dalam mata uang ini dihitung 0.
      <router-link to="/acc-budget-control" class="text-white font-weight-bold"><u>Isi kurs di Budget Control</u></router-link>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-lg-6">
              <div class="card-header pb-0">
                <h6>Profit &amp; Loss per Proyek</h6>
                <p class="text-xs mb-0">Pendapatan = invoice ke client. Biaya = PO yang barangnya sudah diterima + biaya lain. Semua excl. PPN, dalam IDR.</p>
              </div>
            </div>
            <div class="col-lg-4">
              <input type="text" class="form-control mt-3" placeholder="Cari WO / Proyek / Client" v-model="search" v-on:keyup.enter="get()">
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">WO</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Proyek</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Nilai Kontrak</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Pendapatan</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Biaya Aktual</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Laba Kotor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Margin</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Komitmen PO</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Proyeksi Laba</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center"><span class="badge badge-sm bg-gradient-primary">{{ row.wo_code }}</span></td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.project }}</span><br>
                      <span class="text-secondary text-xxs">{{ row.client }}</span>
                    </td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ row.contract_idr > 0 ? fmt(row.contract_idr) : '-' }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.invoiced) }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.actual_cost) }}</span></td>
                    <td class="align-middle text-end"><span :class="'text-xs font-weight-bolder '+(row.gross_profit < 0 ? 'text-danger' : 'text-success')">{{ fmt(row.gross_profit) }}</span></td>
                    <td class="align-middle text-center"><span :class="'text-xs font-weight-bold '+(row.margin < 0 ? 'text-danger' : '')">{{ row.margin !== null ? row.margin+'%' : '-' }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.po_commitment) }}</span></td>
                    <td class="align-middle text-end">
                      <span :class="'text-xs font-weight-bold '+(row.projected_profit < 0 ? 'text-danger' : '')">{{ fmt(row.projected_profit) }}</span>
                      <span class="text-xxs" v-if="row.projected_margin !== null"><br>({{ row.projected_margin }}%)</span>
                    </td>
                    <td><i class="fa fa-eye fa-sm" aria-hidden="true" title="Lihat detail P&L, kontrak, invoice, dan biaya proyek" style="cursor: pointer;" @click="openDetail(row.wo_code)"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL DETAIL PROYEK ======= -->
  <div class="container">
    <vue-final-modal v-model="formDetail.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">P&amp;L {{ woCode }}{{ detail.wo ? ' - '+detail.wo.project : '' }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formDetail.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item" v-for="(tab, i) in tabs" :key="'tab'+i">
            <a :class="'nav-link text-sm '+(activeTab == tab.key ? 'active' : '')" href="javascript:void(0)" @click="activeTab = tab.key">{{ tab.label }}</a>
          </li>
        </ul>

        <!-- RINGKASAN LABA RUGI -->
        <div v-if="activeTab == 'summary'">
          <table class="table table-sm text-sm">
            <tbody>
              <tr><td>Nilai Kontrak</td><td class="text-end">{{ fmt(s.contract_idr) }}</td></tr>
              <tr><td class="font-weight-bold">Pendapatan (invoice ke client)</td><td class="text-end font-weight-bold">{{ fmt(s.invoiced) }}</td></tr>
              <tr><td class="ps-4 text-xs">Sudah dibayar client</td><td class="text-end text-xs">{{ fmt(s.collected) }}</td></tr>
              <tr><td class="ps-4 text-xs">Piutang (belum dibayar client)</td><td class="text-end text-xs">{{ fmt(s.receivable) }}</td></tr>
              <tr><td class="ps-4 text-xs">Belum ditagih</td><td class="text-end text-xs">{{ fmt(s.unbilled) }}</td></tr>
              <tr><td>Biaya PO (barang sudah diterima)</td><td class="text-end">({{ fmt(s.po_actual) }})</td></tr>
              <tr><td>Biaya Lain</td><td class="text-end">({{ fmt(s.other_cost) }})</td></tr>
              <tr :class="s.gross_profit < 0 ? 'text-danger' : 'text-success'">
                <td class="font-weight-bolder">LABA KOTOR AKTUAL</td>
                <td class="text-end font-weight-bolder">{{ fmt(s.gross_profit) }} <span v-if="s.margin !== null">({{ s.margin }}%)</span></td>
              </tr>
              <tr><td colspan="2" class="pt-3 text-xs text-secondary">PROYEKSI (kalau semua PO sudah datang & kontrak tertagih penuh)</td></tr>
              <tr><td>Komitmen PO (barang belum datang)</td><td class="text-end">({{ fmt(s.po_commitment) }})</td></tr>
              <tr :class="s.projected_profit < 0 ? 'text-danger' : ''">
                <td class="font-weight-bolder">PROYEKSI LABA</td>
                <td class="text-end font-weight-bolder">{{ fmt(s.projected_profit) }} <span v-if="s.projected_margin !== null">({{ s.projected_margin }}%)</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- KONTRAK & INVOICE -->
        <div v-if="activeTab == 'revenue'">
          <h6 class="text-sm">Nilai Kontrak</h6>
          <div class="row mb-3">
            <div class="col-md-3"><label class="form-control-label">No. Kontrak / PO Client</label><input type="text" class="form-control form-control-sm" v-model="contract.contract_no"></div>
            <div class="col-md-3"><label class="form-control-label">Nilai Kontrak (excl. PPN) <span style="color: red;">*</span></label><input type="number" step="0.01" min="0" class="form-control form-control-sm" v-model="contract.contract_value"></div>
            <div class="col-md-2"><label class="form-control-label">Mata Uang</label><select class="form-select form-select-sm" v-model="contract.currency"><option v-for="(c, k) in detail.currencies" :key="'cc'+k" :value="c">{{ c }}</option></select></div>
            <div class="col-md-3"><label class="form-control-label">Catatan</label><input type="text" class="form-control form-control-sm" v-model="contract.note"></div>
            <div class="col-md-1"><argon-button style="margin-top: 30px;" variant="gradient" color="success" size="sm" @click="saveContract()">Simpan</argon-button></div>
          </div>

          <h6 class="text-sm">Invoice ke Client</h6>
          <table class="table table-sm align-items-center">
            <thead><tr>
              <th class="text-xxs text-secondary">No. Invoice</th><th class="text-xxs text-secondary">Tanggal</th><th class="text-xxs text-secondary">Keterangan</th><th class="text-xxs text-secondary text-end">Nilai (excl. PPN)</th><th class="text-xxs text-secondary text-center">Status</th><th></th>
            </tr></thead>
            <tbody>
              <tr v-for="(inv, i) in detail.invoices" :key="'inv'+i">
                <td class="text-xs">{{ inv.invoice_no }}</td>
                <td class="text-xs">{{ moment(inv.invoice_date).locale('id').format('LL') }}</td>
                <td class="text-xs">{{ inv.description }}</td>
                <td class="text-xs text-end">{{ inv.currency }} {{ num(inv.amount) }}</td>
                <td class="text-xs text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="inv.status == 'Paid'">Paid {{ inv.paid_date ? moment(inv.paid_date).format('DD/MM/YY') : '' }}</span>
                  <span class="badge badge-sm bg-gradient-secondary" v-else>Unpaid</span>
                </td>
                <td class="text-xs">
                  <i class="fas fa-edit" style="cursor: pointer; margin-right: 12px;" title="Ubah invoice" @click="editInvoice(inv)"></i>
                  <i class="fa fa-trash" style="cursor: pointer;" title="Hapus invoice" @click="deleteInvoice(inv)"></i>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-md-2"><label class="form-control-label">No. Invoice <span style="color: red;">*</span></label><input type="text" class="form-control form-control-sm" v-model="invoice.invoice_no"></div>
            <div class="col-md-2"><label class="form-control-label">Tanggal <span style="color: red;">*</span></label><input type="date" class="form-control form-control-sm" v-model="invoice.invoice_date"></div>
            <div class="col-md-2"><label class="form-control-label">Keterangan</label><input type="text" class="form-control form-control-sm" v-model="invoice.description"></div>
            <div class="col-md-2"><label class="form-control-label">Nilai <span style="color: red;">*</span></label><input type="number" step="0.01" min="0" class="form-control form-control-sm" v-model="invoice.amount"></div>
            <div class="col-md-1"><label class="form-control-label">Kurs</label><select class="form-select form-select-sm" v-model="invoice.currency"><option v-for="(c, k) in detail.currencies" :key="'ic'+k" :value="c">{{ c }}</option></select></div>
            <div class="col-md-1"><label class="form-control-label">Status</label><select class="form-select form-select-sm" v-model="invoice.status"><option value="Unpaid">Unpaid</option><option value="Paid">Paid</option></select></div>
            <div class="col-md-2">
              <argon-button style="margin-top: 30px;" variant="gradient" color="success" size="sm" @click="saveInvoice()">{{ invoice.id ? 'Update' : '+ Tambah' }}</argon-button>
              <a href="javascript:void(0)" class="text-xs ms-2" v-if="invoice.id" @click="resetInvoice()">batal</a>
            </div>
            <div class="col-md-2" v-if="invoice.status == 'Paid'"><label class="form-control-label">Tgl Dibayar</label><input type="date" class="form-control form-control-sm" v-model="invoice.paid_date"></div>
          </div>
        </div>

        <!-- BIAYA LAIN -->
        <div v-if="activeTab == 'cost'">
          <table class="table table-sm align-items-center">
            <thead><tr>
              <th class="text-xxs text-secondary">Tanggal</th><th class="text-xxs text-secondary">Kategori</th><th class="text-xxs text-secondary">Keterangan</th><th class="text-xxs text-secondary text-end">Nilai</th><th></th>
            </tr></thead>
            <tbody>
              <tr v-for="(row, i) in detail.costs" :key="'cost'+i">
                <td class="text-xs">{{ moment(row.cost_date).locale('id').format('LL') }}</td>
                <td class="text-xs">{{ row.category }}</td>
                <td class="text-xs">{{ row.description }}</td>
                <td class="text-xs text-end">{{ row.currency }} {{ num(row.amount) }}</td>
                <td class="text-xs">
                  <i class="fas fa-edit" style="cursor: pointer; margin-right: 12px;" title="Ubah biaya" @click="editCost(row)"></i>
                  <i class="fa fa-trash" style="cursor: pointer;" title="Hapus biaya" @click="deleteCost(row)"></i>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-md-2"><label class="form-control-label">Tanggal <span style="color: red;">*</span></label><input type="date" class="form-control form-control-sm" v-model="cost.cost_date"></div>
            <div class="col-md-2"><label class="form-control-label">Kategori <span style="color: red;">*</span></label><select class="form-select form-select-sm" v-model="cost.category"><option v-for="(c, k) in detail.costCategories" :key="'cat'+k" :value="c">{{ c }}</option></select></div>
            <div class="col-md-3"><label class="form-control-label">Keterangan</label><input type="text" class="form-control form-control-sm" v-model="cost.description"></div>
            <div class="col-md-2"><label class="form-control-label">Nilai <span style="color: red;">*</span></label><input type="number" step="0.01" min="0" class="form-control form-control-sm" v-model="cost.amount"></div>
            <div class="col-md-1"><label class="form-control-label">Kurs</label><select class="form-select form-select-sm" v-model="cost.currency"><option v-for="(c, k) in detail.currencies" :key="'kc'+k" :value="c">{{ c }}</option></select></div>
            <div class="col-md-2">
              <argon-button style="margin-top: 30px;" variant="gradient" color="success" size="sm" @click="saveCost()">{{ cost.id ? 'Update' : '+ Tambah' }}</argon-button>
              <a href="javascript:void(0)" class="text-xs ms-2" v-if="cost.id" @click="resetCost()">batal</a>
            </div>
          </div>
          <h6 class="text-sm mt-4" v-if="detail.otherByCategory.length > 0">Total per Kategori</h6>
          <p class="text-xs mb-0" v-for="(c, i) in detail.otherByCategory" :key="'oc'+i">{{ c.name }}: <b>{{ fmt(c.amount) }}</b></p>
        </div>

        <!-- BIAYA PO PER KATEGORI -->
        <div v-if="activeTab == 'po'">
          <p class="text-xs">Nilai PO excl. PPN dalam IDR. "Aktual" = bagian barang yang sudah diterima (masuk P&amp;L), "Komitmen" = sisa PO yang barangnya belum datang.</p>
          <table class="table table-sm align-items-center">
            <thead><tr>
              <th class="text-xxs text-secondary">Kategori</th><th class="text-xxs text-secondary text-end">Nilai PO</th><th class="text-xxs text-secondary text-end">Aktual (diterima)</th><th class="text-xxs text-secondary text-end">Komitmen</th>
            </tr></thead>
            <tbody>
              <tr v-for="(c, i) in detail.poByCategory" :key="'po'+i">
                <td class="text-xs">{{ c.name }}</td>
                <td class="text-xs text-end">{{ fmt(c.committed) }}</td>
                <td class="text-xs text-end">{{ fmt(c.actual) }}</td>
                <td class="text-xs text-end">{{ fmt(c.committed - c.actual) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccProfitLoss",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      moment: moment,
      table: { data: [] },
      totals: {},
      missingRates: [],
      search: '',
      formDetail: { show: false },
      woCode: '',
      detail: { wo: null, summary: {}, invoices: [], costs: [], poByCategory: [], otherByCategory: [], currencies: [], costCategories: [] },
      activeTab: 'summary',
      tabs: [
        { key: 'summary', label: 'Ringkasan Laba Rugi' },
        { key: 'revenue', label: 'Kontrak & Invoice' },
        { key: 'cost', label: 'Biaya Lain' },
        { key: 'po', label: 'Biaya PO per Kategori' },
      ],
      contract: {},
      invoice: {},
      cost: {},
    };
  },
  computed: {
    s() {
      return this.detail.summary || {};
    },
    cards() {
      let t = this.totals;
      return [
        { label: 'Pendapatan', value: this.fmt(t.invoiced), color: '' },
        { label: 'Biaya Aktual', value: this.fmt(t.actual_cost), color: '' },
        { label: 'Laba Kotor', value: this.fmt(t.gross_profit), color: t.gross_profit < 0 ? 'text-danger' : 'text-success' },
        { label: 'Margin', value: (t.margin !== null && t.margin !== undefined) ? t.margin+'%' : '-', color: '' },
        { label: 'Komitmen PO', value: this.fmt(t.po_commitment), color: '' },
        { label: 'Piutang Client', value: this.fmt(t.receivable), color: 'text-warning' },
      ];
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    num(value) {
      return Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    get() {
      let context = this;
      Api(context, accounting.profitLoss({ search: context.search })).onSuccess(function(response) {
          context.table.data   = response.data.data.data;
          context.totals       = response.data.data.totals;
          context.missingRates = response.data.data.missingRates;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    loadDetail() {
      let context = this;
      Api(context, accounting.showProfitLoss(context.woCode)).onSuccess(function(response) {
          context.detail   = response.data.data;
          let contract     = context.detail.contract;
          context.contract = {
            wo_code:        context.woCode,
            contract_no:    contract ? contract.contract_no : '',
            contract_value: contract ? contract.contract_value : '',
            currency:       contract ? contract.currency : 'IDR',
            note:           contract ? contract.note : '',
          };
          context.formDetail.show = true;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    openDetail(woCode) {
      this.woCode    = woCode;
      this.activeTab = 'summary';
      this.resetInvoice();
      this.resetCost();
      this.loadDetail();
    },
    afterSave(message) {
      this.notify(message, 'success');
      this.loadDetail();
      this.get();
    },
    saveContract() {
      let context = this;
      if (context.contract.contract_value === '' || Number(context.contract.contract_value) < 0) {
        return alert('Nilai Kontrak wajib diisi');
      }
      Api(context, accounting.saveContract(context.contract)).onSuccess(function() {
          context.afterSave('Kontrak Disimpan');
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Kontrak Gagal Disimpan', 'error')
      })
      .call();
    },
    resetInvoice() {
      this.invoice = { id: null, invoice_no: '', invoice_date: moment().format('YYYY-MM-DD'), description: '', amount: '', currency: (this.contract && this.contract.currency) ? this.contract.currency : 'IDR', status: 'Unpaid', paid_date: '' };
    },
    editInvoice(inv) {
      this.invoice = Object.assign({}, inv, { paid_date: inv.paid_date || '' });
    },
    saveInvoice() {
      let context = this;
      if (!context.invoice.invoice_no || !context.invoice.invoice_date || !(Number(context.invoice.amount) > 0)) {
        return alert('No. Invoice, Tanggal, dan Nilai wajib diisi');
      }
      Api(context, accounting.saveInvoice(Object.assign({ wo_code: context.woCode }, context.invoice))).onSuccess(function() {
          context.resetInvoice();
          context.afterSave('Invoice Disimpan');
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Invoice Gagal Disimpan', 'error')
      })
      .call();
    },
    deleteInvoice(inv) {
      if (!confirm('Hapus invoice '+inv.invoice_no+'?')) {
        return;
      }
      let context = this;
      Api(context, accounting.deleteInvoice(inv.id)).onSuccess(function() {
          context.afterSave('Invoice Dihapus');
      }).call();
    },
    resetCost() {
      this.cost = { id: null, cost_date: moment().format('YYYY-MM-DD'), category: 'Tenaga Kerja', description: '', amount: '', currency: 'IDR' };
    },
    editCost(row) {
      this.cost = Object.assign({}, row);
    },
    saveCost() {
      let context = this;
      if (!context.cost.cost_date || !context.cost.category || !(Number(context.cost.amount) > 0)) {
        return alert('Tanggal, Kategori, dan Nilai wajib diisi');
      }
      Api(context, accounting.saveCost(Object.assign({ wo_code: context.woCode }, context.cost))).onSuccess(function() {
          context.resetCost();
          context.afterSave('Biaya Disimpan');
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Biaya Gagal Disimpan', 'error')
      })
      .call();
    },
    deleteCost(cost) {
      if (!confirm('Hapus biaya '+cost.category+' '+this.num(cost.amount)+'?')) {
        return;
      }
      let context = this;
      Api(context, accounting.deleteCost(cost.id)).onSuccess(function() {
          context.afterSave('Biaya Dihapus');
      }).call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 4000 });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1100px;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
